import React, { Component } from "react";
import { Row, Col, Carousel, Badge, Button, Modal } from "react-bootstrap";
import { Link } from "react-router-dom";

interface ProductBoxProps {
    service?: string,
    productData: {
        service: string,
        event_id: string,
        id: string,
        label: string,
        description?: string,
        date: string,
        time: string,
        price_huf: number,
        price_eur: number,
        available: number,
        max_num?: number,
        images?: Array<string>,
        box_details?: string,
        box_details_en?: string,
    };
}

interface ProductBoxState {
    service?: string,
    productData: {
        service: string,
        event_id: string,
        id: string,
        label: string,
        description?: string,
        date: string,
        time: string,
        price_huf: number,
        price_eur: number,
        available: number,
        max_num?: number,
        images?: Array<string>,
        box_details?: string,
        box_details_en?: string,
    },
    translations: Record<string, any>,
    showDetailsModal: boolean
}

class ProductBox extends Component<ProductBoxProps, ProductBoxState> {
    constructor(props: ProductBoxProps) {
        super(props);
        const translations = JSON.parse(localStorage.getItem('translations') || '[]');
        this.state = {
            service: this.props.service ? this.props?.service : '',
            productData: this.props.productData,
            translations: translations,
            showDetailsModal: false
        };
    }

    private navigatePage(url: string) {
        window.location.href = url;
    }

    private getDetailsContent(): string {
        const lang = localStorage.getItem('language') || 'en';
        const { box_details, box_details_en } = this.state.productData;
        return (lang === 'hu' ? (box_details || box_details_en) : (box_details_en || box_details)) || '';
    }

    render() {
        const detailsContent = this.getDetailsContent();
        const detailsLabel = (localStorage.getItem('language') || 'en') === 'hu' ? 'Részletek' : 'Details';
        return (
            <div className="oc-product-box">
                <Row>
                    <Col lg={5} md={5} sm={12} xs={12}>
                        <Carousel controls={false}>
                            { this.state.productData.images?.map((img, index) => (
                                <Carousel.Item key={index}>
                                    <figure
                                        className="oc-product-image"
                                        style={{ backgroundImage: `url(${img})`, backgroundSize: 'cover', backgroundPosition: 'center' }}>
                                    </figure>
                                </Carousel.Item>
                            )) }
                        </Carousel>
                    </Col>
                    <Col lg={7} md={7} sm={12} xs={12}>
                        <Badge
                            bg={this.state.productData.available < 5 && this.state.productData.available > 0 ? "danger" : this.state.productData.available === 0 ? "dark" : ''}
                            className="oc-product-available">
                            { this.state.productData.available > 0 ?
                            this.state.translations.filter((item: any) => item.setting_name === 'FEW_LEFT')[0].setting_value_text :
                            this.state.translations.filter((item: any) => item.setting_name === 'SOLD_OUT')[0].setting_value_text }
                        </Badge>
                        <h4>{this.state.productData.label}</h4>
                        <h5>{this.state.productData.date} - <span>{this.state.productData.time}</span></h5>
                        <p>{this.state.productData.description}</p>
                        <p className="oc-product-price">
                            {this.state.translations.filter((item: any) => item.setting_name === 'DNC_PRICE_TEXT')[0].setting_value_text}:<br />
                            <strong>{this.state.translations.filter((item: any) => item.setting_name === 'FROM_ONLY_EN')[0].setting_value_text}{this.state.productData.price_huf} {this.state.translations.filter((item: any) => item.setting_name === 'HUF_PERSON')[0].setting_value_text}</strong>
                        </p>
                        <div className="oc-product-actions">
                            { detailsContent !== '' &&
                            <Button className="oc-btn-details" onClick={() => this.setState({ showDetailsModal: true })}>
                                {detailsLabel}
                            </Button>
                            }
                            <Link to={`/details/${this.state.service}/${this.state.productData.id}/${this.state.productData.event_id}/${this.state.productData.date}/${this.state.productData.time}/${this.state.productData.max_num ?? 0}`} className="oc-service-link">
                                <span className="">{this.state.translations.filter((item: any) => item.setting_name === 'TOVABB')[0].setting_value_text}</span>
                                <svg width="17" height="15" viewBox="0 0 17 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M15.0454 7.81824L9.04541 1.81824L15.0454 7.81824ZM15.0454 7.81824L9.04541 13.8182L15.0454 7.81824ZM15.0454 7.81824H1.04541H15.0454Z" fill="#D22024"/>
                                    <path d="M15.0454 7.81824L9.04541 1.81824M15.0454 7.81824L9.04541 13.8182M15.0454 7.81824H1.04541" stroke="#D22024" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                                </svg>
                            </Link>
                        </div>
                    </Col>
                </Row>

                <Modal
                    show={this.state.showDetailsModal}
                    onHide={() => this.setState({ showDetailsModal: false })}
                    centered
                    fullscreen="sm-down"
                    dialogClassName="oc-details-modal-dialog"
                    contentClassName="oc-details-modal"
                >
                    <Modal.Body className="oc-details-modal-body">
                        <button
                            type="button"
                            className="oc-details-modal-close"
                            aria-label={detailsLabel === 'Részletek' ? 'Bezárás' : 'Close'}
                            onClick={() => this.setState({ showDetailsModal: false })}
                        >
                            <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M2 2L18 18M18 2L2 18" stroke="#D22023" stroke-width="3" stroke-linecap="round"/>
                            </svg>
                        </button>
                        <div className="oc-details-modal-content" dangerouslySetInnerHTML={{ __html: detailsContent }} />
                    </Modal.Body>
                </Modal>
            </div>
        );
    }
}

export default ProductBox;
